import React from 'react'
import { BuilderComponentState } from '@builder.io/react/dist/types/src/components/builder-component.component'
import { Builder } from '@builder.io/react'

type PaymentPlanNoticeProps = {
  noticeText?: string
  builderState?: BuilderComponentState
}

export function FallbackPaymentPlanNotice(): React.ReactElement {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-light text-left">
        {`Your payment amounts displayed are the estimated costs for your order
        based on how your plan usually covers supplies.`}
      </p>
      <p className="font-light text-left">
        {`Upon placing your order, our team will verify your insurance and obtain
        all necessary paperwork from your doctor per your insurance guidelines.`}
      </p>
    </div>
  )
}

// Uses rich text input type
function PaymentPlanNotice({
  noticeText,
  builderState
}: PaymentPlanNoticeProps ): React.ReactElement {
  const text = noticeText || builderState?.state?.noticeText

  return (
    <div
      className="flex flex-col gap-4"
      dangerouslySetInnerHTML={{
        __html: text || ``
      }}
    />
  )
}

// Register the component with Builder.io
Builder.registerComponent( PaymentPlanNotice, {
  name: `PaymentPlanNotice`,
  inputs: [
    {
      name: `noticeText`,
      type: `richText`,
      defaultValue: `Your payment amounts displayed are the estimated costs for your order
      based on how your plan usually covers supplies.`
    }
  ],
  // This ensures the component appears in the Builder.io editor
  noWrap: true,
  canHaveChildren: false
})

export default PaymentPlanNotice